import React, { useState } from "react";
import "./hidayet.scss"
import { PhotoColumn } from "../../components/photo-column";
import hidayetGunesi from "../../assets/photos/hidayet-gunesi/allahin-hidayet-gunesi_600.jpg";
import hidayetGunesiMini from "../../assets/photos/hidayet-gunesi/allahin-hidayet-gunesi-mini.jpg";
import HidayetSectionBox from "./hidayet-section-box";
import HidayetGunesi from "./hidayet-gunesi";
import HavradanKilisedenCamiye from "./havra-kilise-cami";
import JackieJackson from "./jackie-jackson";
import SamuelRichards from "./samuel-richards";
import HathorZemzem from "./hathor-zemzem";
import IbrahimSahidi from "./ibrahim-sahidi";
import { HathorZemzemDescription, HavraKiliseCamiDescription, HidayetDescription, IbrahimSahidiDescription, JackieJacksonDescription, MesihMuratDescription, MuhammedAliDescription, RecepDescription, SamiBuhariDescription, SamuelRichardsDescription, SarahSareDescription } from "./hidayet-summary-description";
import SamiBuhari from "./sami-buhari";
import MesihMurat from "./mesih-murat";
import RicardoPerez from "./ricardo-perez";
import SarahSare from "./sarah-sare";
import MuhammedAli from "./muhammed-ali";
import PDFViewer from "./guest-notebook-link";

const misafirDefteri = require('../../assets/pdfs/semaokulu_misafir_defteri.pdf');
const misafirDefteri2 = require('../../assets/pdfs/semaokulu_misafir_defteri-2.pdf');

const Hidayet = () => {
    const [IsVisibleMainHidayetSection, setIsVisibleMainHidayetSection] = useState(true);
    const [SectionBoxesVisibility, setSectionBoxesVisibility] = useState({
        IsFirstBoxVisible: false,
        IsSecondBoxVisible: false,
        IsThirdBoxVisible: false,
        IsFourthBoxVisible: false,
        IsFifthBoxVisible: false,
        IsSixthBoxVisible: false,
        IsSeventhBoxVisible: false,
        IsEighthBoxVisible: false,
        IsNinthBoxVisible: false,
        IsTenthBoxVisible: false,
        IsEleventhBoxVisible: false
    });

    const onClickSectionBox = (boxNumber: number) => {
        scrollToTopWithAnimation();
        setIsVisibleMainHidayetSection(false);
        setSectionBoxesVisibility({
            IsFirstBoxVisible: boxNumber === 1,
            IsSecondBoxVisible: boxNumber === 2,
            IsThirdBoxVisible: boxNumber === 3,
            IsFourthBoxVisible: boxNumber === 4,
            IsFifthBoxVisible: boxNumber === 5,
            IsSixthBoxVisible: boxNumber === 6,
            IsSeventhBoxVisible: boxNumber === 7,
            IsEighthBoxVisible: boxNumber === 8,
            IsNinthBoxVisible: boxNumber === 9,
            IsTenthBoxVisible: boxNumber === 10,
            IsEleventhBoxVisible: boxNumber === 11

        });
    }

    const scrollToTopWithAnimation = () => {
        const scrollStep = -150;

        const scrollInterval = setInterval(() => {
            if (window.scrollY === 0) {
                clearInterval(scrollInterval);
            } else {
                window.scrollBy(0, scrollStep);
            }
        }, 15);
    };

    const comeBackSemaSection = () => {
        setIsVisibleMainHidayetSection(true);
        setSectionBoxesVisibility({
            IsFirstBoxVisible: false,
            IsSecondBoxVisible: false,
            IsThirdBoxVisible: false,
            IsFourthBoxVisible: false,
            IsFifthBoxVisible: false,
            IsSixthBoxVisible: false,
            IsSeventhBoxVisible: false,
            IsEighthBoxVisible: false,
            IsNinthBoxVisible: false,
            IsTenthBoxVisible: false,
            IsEleventhBoxVisible: false
        })
    }

    const {
        IsFirstBoxVisible, IsSecondBoxVisible, IsThirdBoxVisible, IsFourthBoxVisible, IsFifthBoxVisible, IsSixthBoxVisible,
        IsSeventhBoxVisible, IsEighthBoxVisible, IsNinthBoxVisible, IsTenthBoxVisible, IsEleventhBoxVisible
    } = SectionBoxesVisibility;
    return (
        <section className="hidayet-section">
            <HidayetGunesi isVisible={IsFirstBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <HavradanKilisedenCamiye isVisible={IsSecondBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <JackieJackson isVisible={IsThirdBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <SamuelRichards isVisible={IsFourthBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <HathorZemzem isVisible={IsFifthBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <IbrahimSahidi isVisible={IsSixthBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <SamiBuhari isVisible={IsSeventhBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <MesihMurat isVisible={IsEighthBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <RicardoPerez isVisible={IsNinthBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <SarahSare isVisible={IsTenthBoxVisible} comeBackSemaSection={comeBackSemaSection} />
            <MuhammedAli isVisible={IsEleventhBoxVisible} comeBackSemaSection={comeBackSemaSection} />

            <div style={{ display: IsVisibleMainHidayetSection ? "block" : "none" }}>
                <h3 className="section-title">ALLAH'IN HİDAYET GÜNEŞİ'NİN DOĞMASI</h3>
                <PhotoColumn
                    imageSource={hidayetGunesi}
                    imageTitle="Ali Yakub Babacan"
                    imageSourceList={[{ src: hidayetGunesiMini, width: 300 }, { src: hidayetGunesi, width: 600 }]}
                />

                <h4 className="section-title">MİSAFİR DEFTERLERİ</h4>

                <div className="misafir-defteri">
                    <PDFViewer pdfSource={misafirDefteri} title="Birinci Defter'e Git" />
                    <PDFViewer pdfSource={misafirDefteri2} title="İkinci Defter'e Git" />
                </div>

                <div className="hidayet-section__content">
                    <HidayetSectionBox
                        boxTitle={<div>Allah'ın Hidayet Güneşi</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={1}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<HidayetDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>Havra'dan Kilise'den Camii'ye</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={2}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<HavraKiliseCamiDescription />}
                    />
                </div>

                <h3 className="section-title">İslam'a Girenlerin Öyküleri</h3>

                <div className="hidayet-section__content">
                    <HidayetSectionBox
                        boxTitle={<div>JACKIE JACKSON<br />MESİH CEMAL CEM</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={3}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<JackieJacksonDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>PROF. SAMUEL RICHARDS<br />SÜLEYMAN</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={4}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<SamuelRichardsDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>HATHOR ZEMZEM</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={5}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<HathorZemzemDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>DANİELE MARİA İGİNO<br />İBRAHİM ŞAHİDİ</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={6}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<IbrahimSahidiDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>MUHAMMED SAMİ BUHARİ<br />SALAMON SALMAN</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={7}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<SamiBuhariDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>MESİH MURAT SAMİ<br />MARTİN JOHN MWAİPOPO</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={8}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<MesihMuratDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>RECEB<br />Ricardo Peres</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={9}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<RecepDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>SARAH SARE</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={10}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<SarahSareDescription />}
                    />

                    <HidayetSectionBox
                        boxTitle={<div>MUHAMMED ALİ</div>}
                        buttonTitle="Devamını Oku"
                        boxNumber={11}
                        onClickSectionBox={onClickSectionBox}
                        summaryDescription={<MuhammedAliDescription />}
                    />
                </div>
            </div>
        </section>

    );
}

export default Hidayet;